import React from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";

export default function PageHeader({ children, showBack = false, onBack }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2">
        {showBack && (
          <button
            onClick={handleBack}
            className="text-gray-600 hover:text-gray-800 p-1 flex items-center"
          >
            <IoChevronBack size={22} />
          </button>
        )}

        <h2 className="text-title">{children}</h2>
      </div>

      <div className="h-px bg-gray-300 mt-2"></div>
    </div>
  );
}
